<template>
  <div class="hotdata">
    <ul class="hotdata-ul">
      <draggable
        tag="el-collapse"
        :list="hotData"
        @end="endDrag"
      >

        <li
          class="hotdata-ul-li"
          :class="[{notActive:activeIndex !== index}]"
          v-for="(item,index) in hotData"
          :key="item.id"
          @click="changeStatus(index)"
        >
          <div
            class="hotdata-ul-li-top"
            :class="[{active:activeIndex === index,lastActive:lastIndex === index}]"
          >
            <div class="left">
              <img :src="activeIndex === index ? item.activeIcon : item.icon" />
              <span>{{item.dataName}}</span>
            </div>
            <div class="right">
              <template v-for="(rightItem,rightIndex) in hotDataRight">
                <div
                  class="right-data"
                  v-if="rightItem.dataType === item.dataType"
                  :key="rightIndex"
                >{{rightItem.title}}： {{rightItem.data}}{{rightItem.dataUnit}}</div>
              </template>
              <template v-if="activeIndex === index">
                <img
                  :src="require('@/assets/Home/Index/HotData/top-icon.png')"
                  alt=""
                >
              </template>
              <template v-else>
                <img
                  :src="require('@/assets/Home/Index/HotData/bottom-icon.png')"
                  alt=""
                >
              </template>
            </div>
          </div>
          <div class="hotdata-ul-li-bottom">
            <transition name="fade">
              <components
                :showNetWorkInfo="showNetWorkInfo"
                :key="item.dataType"
                :is="item.dataType"
                :schoolCode="schoolCode"
                v-show="activeIndex === index"
                :data="allData[item.dataType]"
                class="component"
              />
            </transition>

          </div>
          <div>
          </div>
        </li>
      </draggable>

    </ul>
    <el-dialog
      title="提示"
      :visible.sync="creatNetWorkVisible"
      width="424px"
      append-to-body
      custom-class="portal-dialog"
      :close-on-click-modal="false"
    >
      <div class="dialog-content">
        <img
          class="header-icon"
          :src="require('@/assets/remind-tip.png')"
        >
        <span class="info">
          您尚未创建上网账号，可以前往创建，如果暂时不想创建，可以暂时点击“跳过”或者勾选“不再提醒”后永久跳过。后续可以在消息提醒中通过点击提醒链接进行创建。
        </span>
        <div class="dialog-footer">
          <el-checkbox
            v-model="networkRemind"
            @change="changeRemindStatus"
          >不再提醒</el-checkbox>
          <span style="flex:1"></span>
          <el-button
            round
            @click="cancel"
          >跳过</el-button>
          <el-button
            round
            type="primary"
            @click="confirm"
          >前往创建</el-button>
        </div>
      </div>
    </el-dialog>
  </div>

</template>
<script>
// 资产
import Assets from "./HotData/Assets";
// 校园卡
import SchoolCard from "./HotData/SchoolCard";
// 科研
import Scientific from "./HotData/Scientific";
// 论文
import Thesis from "./HotData/Thesis";
// 图书
import Books from "./HotData/Books";
// 网费
import NetworkFee from "./HotData/NetworkFee";
import draggable from "vuedraggable";
import {
  getRecordPreviewHistory,
  setRecordPreviewHistory,
} from "@/api/user.js";
import { getUserInfo } from "@/api/sign.js";
import {
  getPropertyInfo,
  getMyBooks,
  getNetworkFeeInfo,
  getMyECard,
  getScientificResearch,
  getPaper,
} from "@/api/personalData-v2.js";
import { getNetworkAccount } from "@/api/personalData-v2";
import { mapGetters } from "vuex";
import configR from '@/configs.js';
export default {
  name: "HotData",
  data() {
    return {
      schoolCode: config.SCHOOL_CODE,
      creatNetWorkVisible: false,
      networkRemind: false,
      showNetWorkInfo: true,
      activeIndex: 0,
      lastIndex: 0,
      activeNames: [1],
      allData: {
        thesis: {},
        scientific: {},
        schoolCard: {
          balance: "", //一卡通余额
          monthBalance: "", // 本月消费
          pcUrl: "", //pc一卡通详情地址
        },
        networkFee: {},
        books: {},
        assets: {
          propertySum: "", //资产总数
          propertySumUnit: "", // 资产单位
          propertyAmount: "", // 资产总金额
          propertyAmountUnit: "", // 资产金额单位
          pcUrl: "", //pc资产信息详情地址
          propertyInfoList: [], // 资产列表
        },
      },
      hotDataRight: [
        {
          dataType: "scientific",
          dataName: "scientificResearchSum",
          title: "项目总数",
          data: "",
          dataUnit: "项",
        },
        {
          dataType: "thesis",
          dataName: "paperSum",
          title: "认定论文",
          data: "1",
          dataUnit: "篇",
        },
        {
          dataType: "books",
          dataName: "borrowCount",
          title: "未还总数",
          data: "1",
          dataUnit: "册",
        },
        {
          dataType: "networkFee",
          dataName: "userBalance",
          title: "账户余额",
          data: "1",
          dataUnit: "元",
        },
      ],
      dataSortSetting: [
        "assets",
        "schoolCard",
        "scientific",
        "thesis",
        "books",
        "networkFee",
      ],
      showHotDataCards:[],
      hotData:[],
      hotDataTotal: [
        {
          icon: require("@/assets/Home/Index/HotData/assets-grey.svg"),
          activeIcon: require("@/assets/Home/Index/HotData/asset-white.svg"),
          dataName: "资产",
          dataType: "assets",
          id: 1,
        },
        {
          icon: require("@/assets/Home/Index/HotData/credt-card-grey.svg"),
          activeIcon: require("@/assets/Home/Index/HotData/credt-card-white.svg"),
          dataName: "校园卡",
          dataType: "schoolCard",
          id: 2,
        },
        {
          icon: require("@/assets/Home/Index/HotData/science-grey.svg"),
          activeIcon: require("@/assets/Home/Index/HotData/scientice-white.svg"),
          dataName: "科研",
          dataType: "scientific",
          detail: [{ labelName: "" }],
          id: 3,
        },
        {
          icon: require("@/assets/Home/Index/HotData/thesis-grey.svg"),
          activeIcon: require("@/assets/Home/Index/HotData/thesis-white.svg"),
          dataName: "论文",
          dataType: "thesis",
        },
        {
          icon: require("@/assets/Home/Index/HotData/books-grey.svg"),
          activeIcon: require("@/assets/Home/Index/HotData/books-white.svg"),
          dataName: "图书",
          dataType: "books",
          id: 4,
        },
        {
          icon: require("@/assets/Home/Index/HotData/network-fee-grey.svg"),
          activeIcon: require("@/assets/Home/Index/HotData/network-fee-white.svg"),
          dataName: "网费",
          dataType: "networkFee",
          id: 5,
        },
      ],
    };
  },
  components: {
    Assets,
    SchoolCard,
    Scientific,
    Thesis,
    Books,
    NetworkFee,
    draggable,
  },

  async created() {
    // 得到用户的个人数据模块
    this.getHotData();

  },
  computed: {
    ...mapGetters(["userInfo"]),
  },

  methods: {
    // 得到用户的个人数据模块
    getHotData() {
      this.showHotDataCards = configR.envConfigs.SHOW_HOT_DATA_CARDS ? JSON.parse(configR.envConfigs.SHOW_HOT_DATA_CARDS) : [];
      // 不是数组，数组长度为0
      if(!(this.showHotDataCards instanceof Array) || this.showHotDataCards.length === 0) {
        // 不配置卡片
        this.hotData = this.hotDataTotal;
      } else {
        // 配置了卡片
        this.hotDataTotal.forEach( item => {
          this.showHotDataCards.forEach ( hotDataItem => {
            if (hotDataItem.dataType === item.dataType) {
              this.hotData.push(item)
            }
          })
        })
      }
      // 平顶山 -- 校园卡/图书
      if (configR.envConfigs.SCHOOL_CODE === "pingdingshan") {
        this.hotData = [
          {
            icon: require("@/assets/Home/Index/HotData/credt-card-grey.svg"),
            activeIcon: require("@/assets/Home/Index/HotData/credt-card-white.svg"),
            dataName: "校园卡",
            dataType: "schoolCard",
            id: 2,
          },
          {
            icon: require("@/assets/Home/Index/HotData/books-grey.svg"),
            activeIcon: require("@/assets/Home/Index/HotData/books-white.svg"),
            dataName: "图书",
            dataType: "books",
            id: 4,
          },
        ];
      }
      this.$emit("getedHotData", this.hotData.length);
      this.getRequestAllDatas();
    },
    async getRequestAllDatas() {
      // 本地获取提醒状态
      this.getRemindStatus();
      this.getRecordPreviewHistory();
      if (configR.envConfigs.SCHOOL_CODE === "pingdingshan") {
        await this.getMyECard();
        await this.getMyBooks();
      } else {
        await this.getScientificResearch();
        await this.getPaper();
        await this.getMyECard();
        await this.getNetworkFeeInfo();
        await this.getMyBooks();
        await this.getPropertyInfo();
      }
      this.hotDataRight.forEach((item) => {
        item.data = this.allData[item.dataType][item.dataName] || "-";
      });
      this.remindGetNetworkAccount();
    },
    // 隐藏创建账号弹框
    cancel() {
      this.creatNetWorkVisible = false;
    },
    confirm() {
      this.$router.push({ name: "AddNetworkAccount" });
    },
    async getRemindStatus() {
      let uid = (this.userInfo.user && this.userInfo.user.uid) || "";
      try {
        let res = await getUserInfo();
        if (res.code === 0) {
          let userInfo = res.data;
          uid = userInfo.user.uid;
          let networkRemind = this.$store.state.user.networkRemind || {};
          this.networkRemind = networkRemind[uid] || false;
        }
      } catch (e) {}
    },
    changeRemindStatus(val) {
      this.networkRemind = val;
      let uid = this.userInfo.user.uid;
      let networkRemind = this.$store.state.user.networkRemind || {};
      this.$set(networkRemind, uid, val);
      this.$store.commit("SET_NETWORK_REMIND", networkRemind);
    },
    // 提醒用户注册上网账号信息
    async remindGetNetworkAccount() {
      // this.allData.networkFee.registered = true
      try {
        let res = await getNetworkAccount();
        if (res.code !== 0) {
         //  this.$message.error("获取用户注册上网账号信息失败");
          return false;
        }
        let data = res.data;
        if (data.code === "0") {
          // 用户已经注册过账号
          this.creatNetWorkVisible = false;
        } else {
          // 未注册过
          // 不提醒
          this.showNetWorkInfo = false;
          if (this.networkRemind) {
            this.creatNetWorkVisible = false;
            return false;
          }
          this.creatNetWorkVisible = true;
        }
      } catch (e) {
        // this.$message.error("获取用户注册上网账号信息失败");
      }
    },
    changeStatus(index) {
      this.activeIndex = index;
      this.lastIndex = this.activeIndex - 1;
    },
    endDrag(item) {
      // 保持展开的卡片能够随拖动移动保持展开
      if (this.activeIndex === item.oldIndex) {
        this.activeIndex = item.newIndex;
      } else {
        if (this.activeIndex === item.newIndex)
          this.activeIndex = item.oldIndex;
      }
      this.lastIndex = this.activeIndex - 1;
      let sortSetting = [];
      this.hotData.forEach((item) => {
        sortSetting.push(item.dataType);
      });
      try {
        this.setRecordPreviewHistory(sortSetting);
      } catch (e) {}
    },
    async getRecordPreviewHistory() {
      try {
        let res = await getRecordPreviewHistory();
        if (res.code !== 0) {
          // this.$message.error('请求错误!');
          return;
        }
        if (!res.data) {
          return;
        }
        this.dataSortSetting =
          res.data.personalData && res.data.personalData.length > 0
            ? res.data.personalData
            : this.dataSortSetting;
        let mediaArr = [];
        this.dataSortSetting.forEach((dataType) => {
          this.hotData.forEach((dataItem) => {
            if (dataType === dataItem.dataType) mediaArr.push(dataItem);
          });
        });
        this.hotData = mediaArr;
      } catch (e) {
        // this.$message.error('请求错误!');
        return;
      }
    },
    setRecordPreviewHistory(sortSetting) {
      let param = { personalData: sortSetting };
      let res = setRecordPreviewHistory(param);
    },
    async getPaper() {
      try {
        let res = await getPaper({});
        if (res.code !== 0) {
          // this.$message.error('获取论文信息错误!');
          this.$set(this.allData, "thesis", { SystemUpgrading: true });
          return;
        }
        this.$set(this.allData, "thesis", res.data);
      } catch (e) {
        this.$message.error("获取论文信息错误!");
        return;
      }
    },
    async getScientificResearch() {
      try {
        let res = await getScientificResearch({});
        if (res.code !== 0) {
          this.$set(this.allData, "scientific", { SystemUpgrading: true });
          //  this.$message.error('获取科研信息错误!');
          return;
        }
        this.$set(this.allData, "scientific", res.data);
      } catch (e) {
        this.$message.error("获取科研信息错误!");
        return;
      }
    },
    async getMyECard() {
      try {
        let res = await getMyECard({});
        if (res.code !== 0) {
          this.$set(this.allData, "schoolCard", { SystemUpgrading: true });
          // this.$message.error('获取一卡通信息错误!');
          return;
        }
        this.$set(this.allData, "schoolCard", res.data);
      } catch (e) {
        this.$message.error("获取一卡通信息错误!");
        return;
      }
    },
    async getNetworkFeeInfo() {
      try {
        let res = await getNetworkFeeInfo({});
        if (res.code !== 0) {
          //  this.$message.error('获取网费信息错误!');
          this.$set(this.allData, "networkFee", { SystemUpgrading: true });
          return;
        }
        res.data.registered = true;

        this.$set(this.allData, "networkFee", res.data);
        // await this.remindGetNetworkAccount();
      } catch (e) {
        this.$message.error("获取网费信息错误!");
        return;
      }
    },
    async getMyBooks() {
      try {
        let res = await getMyBooks({});
        if (res.code !== 0) {
          this.$set(this.allData, "books", { SystemUpgrading: true });
          //  this.$message.error('获取图书信息错误!');
          return;
        }
        let data = res.data || {};
        this.$set(this.allData, "books", data);
      } catch (e) {
        // this.$message.error("获取图书信息错误!");
        return;
      }
    },
    async getPropertyInfo() {
      try {
        let res = await getPropertyInfo({});
        if (res.code !== 0) {
          //  this.$message.error('获取资产信息错误!');
          return;
        }
        // 把金额换算成万元金额
        res.data.propertyAmount =
          res.data.propertyAmount &&
          Math.floor((res.data.propertyAmount / 10000) * 100) / 100;
        this.$set(this.allData, "assets", res.data);
      } catch (e) {
        this.$message.error("获取资产信息错误！");
        return;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.hotdata {
  background: #fff;
  width: 100%;
  border-top: 4px solid rgb(153, 90, 115);

  &-ul {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    overflow: hidden;
    .el-collapse {
      width: 100%;
      border-top: none;
      display: flex;
      flex-wrap: wrap;
      overflow: hidden;
    }
    &-li {
      &:nth-last-of-type(1) {
        .hotdata-ul-li-top {
          border-bottom: none;
        }
      }
      z-index: 3;
      cursor: pointer;
      width: 100%;
      background: #fff;
      &-top {
        width: 100%;
        display: flex;
        padding-left: 19px;
        padding-right: 15px;
        line-height: 50px;
        border-bottom: 1px solid #d3d3d3;
        color: #1b1b1b;
        justify-content: space-between;
        transition: background-color 0.2s, color 0.2s;
        &.lastActive {
          border-bottom: none;
        }
        &.active {
          background-color: rgb(153, 90, 115);
          color: rgb(255, 255, 255);
          .right {
            &-data {
              color: white;
            }
          }
        }
        .left {
          display: flex;
          align-items: center;
          img {
            width: 22px;
            height: 22px;
            display: inline-block;
            margin-right: 9px;
          }
        }
        .right {
          display: flex;
          align-items: center;
          &-data {
            margin-right: 10px;
            color: rgb(51, 51, 51);
          }
          img {
            width: 26px;
            height: 26px;
            cursor: pointer;
          }
        }
      }
      &-bottom {
        .component {
          // transition:all 6s;
        }
      }
    }
  }
}
.fade-enter {
  height: 0;
  opacity: 1;
}
.fade-enter-active {
  transition: height 0.4s linear;
}
.fade-enter-to {
  opacity: 1;
}
.fade-leave-active {
  transition: height 0.4s linear;
}
.fade-leave-to {
  height: 0;
  opacity: 1;
}
/deep/ .el-dialog.portal-dialog {
  border-radius: 12px;
  overflow: hidden;
  .el-dialog__body {
    padding: 30px 30px 50px 30px;
  }
  .el-dialog__header {
    /*border-radius: 12px;*/
    background: none;
    padding: 13px 20px;
    font-size: 16px;
    font-weight: 500;
    color: #333333;
    line-height: 24px;
  }
  .dialog-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    .header-icon {
      width: 40px;
      height: 40px;
    }
    .info {
      margin-top: 16px;
      color: #333333;
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
    }
    .dialog-footer {
      width: 100%;
      margin-top: 40px;
      display: flex;
      align-items: center;
      line-height: 22px;
    }
  }
}
/*.component-fade-enter-active, .component-fade-leave-active {*/
/*    transition: height .3s ease;*/
/*}*/
/*.component-fade-enter, .component-fade-leave-to*/
/*    !* .component-fade-leave-active for below version 2.1.8 *! {*/
/*    height: 0;*/
/*}*/
</style>